import FlipClock from "../flipClock";

const MonitorSubtitleCountDown = ({ event }) => {
	return event ? <FlipClock dateStr={event.startTime} /> : null;
};
export default MonitorSubtitleCountDown;
